module.exports = __webpack_public_path__ + "img/hrvoje_zubrinic.c706182f.jpg";